import dayjs from 'dayjs';

// Filter type constants for ShopifyOrders module
export const FILTER_TYPES = {
  SEARCH: 'search',
  DATE_RANGE: 'dateRange',
  STORE: 'store',
  FINANCIAL_STATUS: 'financialStatus',
  FULFILLMENT_STATUS: 'fulfillmentStatus',
  SHIPMENT_STATUS: 'shipmentStatus',
  SHIPMENT_DETAIL: 'shipmentDetail',
  CONFIRM_SHIPMENT: 'confirmShipment',
  CATEGORY: 'category',
  COLLECTION: 'collection',
  PRINTER: 'printer',
  SUPPORTER: 'supporter',
  TITLE: 'title',
  SKU: 'sku',
  EMPLOYEE_ID: 'employeeId',
  EXCLUDE_TITLE: 'excludeTitle',
  EXCLUDE_SKU: 'excludeSku',
  BASECOST: 'basecost'
};

export const FILTER_TYPE_LABELS = {
  [FILTER_TYPES.SEARCH]: 'Search',
  [FILTER_TYPES.DATE_RANGE]: 'Date Range',
  [FILTER_TYPES.STORE]: 'Store',
  [FILTER_TYPES.FINANCIAL_STATUS]: 'Financial Status',
  [FILTER_TYPES.FULFILLMENT_STATUS]: 'Fulfillment Status',
  [FILTER_TYPES.SHIPMENT_STATUS]: 'Shipment Status',
  [FILTER_TYPES.SHIPMENT_DETAIL]: 'Shipment Details',
  [FILTER_TYPES.CONFIRM_SHIPMENT]: 'Confirm Shipment',
  [FILTER_TYPES.CATEGORY]: 'Category',
  [FILTER_TYPES.COLLECTION]: 'Collection',
  [FILTER_TYPES.PRINTER]: 'Printer',
  [FILTER_TYPES.SUPPORTER]: 'Supporter',
  [FILTER_TYPES.TITLE]: 'Product Title',
  [FILTER_TYPES.SKU]: 'SKU',
  [FILTER_TYPES.EMPLOYEE_ID]: 'Employee ID',
  [FILTER_TYPES.EXCLUDE_TITLE]: 'Exclude Title',
  [FILTER_TYPES.EXCLUDE_SKU]: 'Exclude SKU',
  [FILTER_TYPES.BASECOST]: 'Base Cost'
};

// Get 45 days range (from 45 days ago to today)
const get45DaysRange = () => {
  const endDate = dayjs().endOf('day');
  const startDate = dayjs().subtract(45, 'days').startOf('day');
  return [startDate, endDate];
};

export const DEFAULT_FILTER_VALUES = {
  [FILTER_TYPES.SEARCH]: '',
  [FILTER_TYPES.DATE_RANGE]: get45DaysRange(),
  [FILTER_TYPES.STORE]: [],
  [FILTER_TYPES.FINANCIAL_STATUS]: [],
  [FILTER_TYPES.FULFILLMENT_STATUS]: [],
  [FILTER_TYPES.SHIPMENT_STATUS]: [],
  [FILTER_TYPES.SHIPMENT_DETAIL]: 'all',
  [FILTER_TYPES.CONFIRM_SHIPMENT]: 'all',
  [FILTER_TYPES.CATEGORY]: [],
  [FILTER_TYPES.COLLECTION]: [],
  [FILTER_TYPES.PRINTER]: [],
  [FILTER_TYPES.SUPPORTER]: [],
  [FILTER_TYPES.TITLE]: '',
  [FILTER_TYPES.SKU]: '',
  [FILTER_TYPES.EMPLOYEE_ID]: '',
  [FILTER_TYPES.EXCLUDE_TITLE]: '',
  [FILTER_TYPES.EXCLUDE_SKU]: '',
  [FILTER_TYPES.BASECOST]: 'all'
};

// Validate filter type
export const isValidFilterType = (type) => {
  return Object.values(FILTER_TYPES).includes(type);
};
